import WebAPI from './WebAPI'
import {
  getLocalDateStringFormatted,
  correctToUTCTime
} from '@/common/U_D'

const API_FOR_ATT = process.env.API_ROOT_NODE

/**
 * Look at the Confluence API article for more information
 * https://audiencematters.atlassian.net/wiki/spaces/AM/pages/448135169/Revision+History
 */
class AttTargetAPI extends WebAPI {
  constructor () {
    super({baseURL: API_FOR_ATT})
  }

  assignAtt ({username, id}) {
    return this.__post({
      extensionURL: '/Audience/assign/ATT',
      payload: {username, id}
    })
  }

  importAtt ({viewing_stream, id, advertiser, username}) {
    return this.__post({
      extensionURL: '/Audience/import/ATT',
      payload: {viewing_stream, id, advertiser, username}
    })
  }

  getATT ({id}) {
    return this.__get({
      query: {id},
      extensionURL: '/Audience/ATT'
    })
  }

  submitATTCampaign ({display_name, target_id, advertiserName, startDate, endDate, cae_id, viewing_stream, file}) {
    const payload = {
      campaignName: display_name,
      clientName: advertiserName,
      startDate: getLocalDateStringFormatted(startDate),
      endDate: getLocalDateStringFormatted(endDate),
      externalId: cae_id,
      dsTypeCd: viewing_stream.toUpperCase(),
      targetDefinition: JSON.stringify({}),
      targetLabel: display_name,
      networkKey: ['13', '15', '21', '59', '77', '97', '103', '105'],
      audTypeCode: ['ATT_FULL', 'ATT_RPD', 'US_FULL'],
      programmerName: 'TURNER',
      status: 'PLANNING',
      targetFile: [{
        fileName: file.name,
        action: file.action,
        fileTypeCd: 'Custom List'
      }],
      target_id
    }
    return this.__post({
      extensionURL: '/Audience/ATT/submitCampaign',
      payload
    }, true)
  }

  updateATTCampaign ({status, startDate, endDate, cae_id}) {
    /**
      status: Joi.string().valid('ORDERED', 'CANCELLED').required(),
      startDate: Joi.string().regex(dateRegex),
      endDate: Joi.string().regex(dateRegex),
      externalId: Joi.number().required()
     */
    return this.__post({
      extensionURL: '/Audience/ATT/updateCampaign',
      payload: {
        status,
        startDate: getLocalDateStringFormatted(startDate),
        endDate: getLocalDateStringFormatted(endDate),
        externalId: cae_id
      }
    })
  }

}

export default new AttTargetAPI()



// WEBPACK FOOTER //
// ./src/app/api/AttAPI.js